import Vue from 'vue'
import VueRouter from 'vue-router'
import Monit from '../views/Monit.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'monit',
    component: Monit
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
